import { FC, ReactNode } from 'react';

import { Link } from '@hh.ru/magritte-ui';
import { ChevronDownOutlinedSize16, ChevronUpOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

interface Props {
    text: ReactNode;
    expanded: boolean;
    onToggle: () => void;
    dataQa?: string;
}

const StaticCollapseTrigger: FC<Props> = ({ text, expanded, onToggle, dataQa }) => {
    return (
        <Link
            typography="label-3-regular"
            iconRight={expanded ? <ChevronUpOutlinedSize16 /> : <ChevronDownOutlinedSize16 />}
            onClick={onToggle}
            data-qa={dataQa}
        >
            {text}
        </Link>
    );
};

export default StaticCollapseTrigger;
